import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core'

import type { ConversationProfile } from '@app/modules/messaging/models/conversation-profile.model'
import { Confirmable } from '@app/modules/ui/models/confirmable'
import { UIModule } from '@app/modules/ui/ui.module'
import { MemberService } from '@app/services/member.service'

@Component({
  selector: 'sb-boost-message-insufficient-credits-modal',
  templateUrl: './boost-message-insufficient-credits-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoostMessageInsufficientCreditsModalComponent extends Confirmable {
  readonly memberService = inject(MemberService)

  @Input({ required: true }) profile!: ConversationProfile
}
